import React from 'react';
import LoadingMessage from '../../components/LoadingMessage/index';
import usePush from '../../hooks/usePush';
import NylasService from '../../services/nylas-service';
import useQueryParams from '../../hooks/useQueryParams';
import { useOnMount } from '@chaser/components';
import useShortCode from '../../hooks/useShortCode';
import ApiError from '../../util/ApiError';

const ConnectNylasCallback = () => {
  const { code, state } = useQueryParams();
  const shortCode = useShortCode();
  const { execute, error } = usePush(NylasService.setNylasToken);

  async function checkToken(code, state) {
    const [err] = await execute({ shortCode, code, state });

    if (err) return;
    window.location.replace('/receivables/manage/email');
  }

  useOnMount(() => {
    if (code && state) {
      checkToken(code, state);
    } else {
      window.location.replace('/receivables/manage/email', { error: 'Sorry, unable to connect to Nylas.' });
    }
  });

  if (error) throw new ApiError(error);

  return <LoadingMessage center useLogoAnimation />;
};

export default ConnectNylasCallback;
